import type { Editor } from ".";
import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useThemeContext } from "@/react/providers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

const localeNamespace = "settings.emails.builder.email_builder_selector.tile";

export const EditorTile = ({
  tileName,
  isSelected,
}: {
  tileName: Editor;
  isSelected: boolean;
}) => {
  const { isDarkAppearance } = useThemeContext();

  if (!tileName) {
    return null;
  }

  return (
    <div
      className={classNames(
        "border-primary flex w-full cursor-pointer flex-col gap-5 rounded-xl border p-3 transition-colors duration-300",
        "hover:border-dark hover:shadow-md",
        {
          "border-secondary hover:border-secondary": isSelected,
        },
      )}
    >
      <div className="bg-secondary h-[144px] rounded-lg">
        <Icon
          type={
            isDarkAppearance
              ? `${tileName}-email-builder-dark`
              : `${tileName}-email-builder`
          }
          viewBox="0 0 244 144"
          className="!w-full"
        />
      </div>
      <div className="mx-1 mb-2 flex flex-col gap-2 text-center">
        <div className="flex justify-center gap-2">
          <Typography.LabelMd weight="bold">
            {t([localeNamespace, tileName, "name"])}
          </Typography.LabelMd>
          {tileName === "visual" && (
            <div className="flex items-center gap-1 rounded bg-blue-500/10 px-1 py-px">
              <Typography.LabelXxs color="text-date-blue">
                {t([localeNamespace, "new"])}
              </Typography.LabelXxs>
            </div>
          )}
        </div>

        <Typography.LabelXs color="text-default" weight="light">
          {t([localeNamespace, tileName, "description"])}
        </Typography.LabelXs>
      </div>
    </div>
  );
};
